var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKwait(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0.335953H0V8.08595H40V0.335953Z",
    fill: "#429976"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8.08594H0V15.875H40V8.08594Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15.875H0V23.6641H40V15.875Z",
    fill: "#BD1F34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.335953V23.6719L11.6641 15.875V8.08595L0.0546875 0.335953H0Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKwait);
export default __webpack_public_path__ + "static/media/kwait.8e388fdbf2b9c43d9f75edabf130b889.svg";
export { ForwardRef as ReactComponent };